import React from "react";
import { AppBar, Toolbar, IconButton, Typography } from "material-ui";
import MenuIcon from "material-ui-icons/Menu";
import logo from "../../images/hypo-logo-nostamp.svg";
import { IsCordova } from "util/platformUtils";
import BackButton from "../BackButton/BackButton";
import ActionButton from "../ActionButton/ActionButton";

interface AppBarProps {
    showLogo: boolean;
    showBackButton: boolean;
    showActionButton: boolean;
    header: string;
    toggleDrawer: (show: boolean) => void;
    showDrawer: boolean;
}

const TopAppBar: React.SFC<AppBarProps> = (props) => {
    return (
        <AppBar position="fixed" role="banner">
            <Toolbar
                className="navbar"
                style={{ paddingLeft: 0, paddingRight: 0 }}
            >
                {(props.showBackButton && (
                    <div className="backButton">
                        <BackButton />
                    </div>
                )) || (
                    <IconButton
                        className={"menuButton"}
                        aria-label="Menu"
                        onClick={() => props.toggleDrawer(true)}
                        autoFocus={IsCordova}
                    >
                        <MenuIcon />
                    </IconButton>
                )}
                <div className="logoWrap" style={{ paddingLeft: 10 }}>
                    {props.showLogo && (
                        <Typography
                            variant="title"
                            color="inherit"
                            className="logo"
                        >
                            <img
                                src={logo}
                                style={{ height: "20px" }}
                                alt="HYPO text logo"
                            />
                        </Typography>
                    )}
                    {props.header && (
                        <h3
                            className={
                                "header" + (!props.showLogo ? " no-border" : "")
                            }
                            key={props.header}
                        >
                            {props.header}
                        </h3>
                    )}
                </div>
                {props.showActionButton && <ActionButton />}
            </Toolbar>
        </AppBar>
    );
};

export default TopAppBar;



// WEBPACK FOOTER //
// ./src/components/AppBar/AppBar.tsx